import { Component, OnInit ,AfterViewInit} from '@angular/core';
import {HomeComponent} from '../home/home.component';

declare var $ : any;

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent implements OnInit,AfterViewInit {
  isNext:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  constructor(private home:HomeComponent) { }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  ngAfterViewInit(){
    $(window).scrollTop(0,0);
    $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  showActiveModule(pvarChoice){
    this.home.showActiveModule(pvarChoice);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/privacy-policy/privacy-policy.component.ts